import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ExportJsonExcel from "js-export-excel";
import Sidebar from "../../../../../partials/aside/Sidebar";
import helperSpinner from "../../../../../../helpers/spinner";
import httpService from "../../../../../../services/httpServices/httpServices";
import helpersNumber from "../../../../../../helpers/numbers";
import helpersTime from "../../../../../../helpers/time";
import moment from "moment";

export default function LogsAmountCampaign() {
  const [logs, setLogs] = useState();
  const params = useParams();
  const campaignID = parseInt(params.id);

  useEffect(() => {
    getCampaignValueLogs();
  }, []);

  const exportLogsExcel = () => {
    var option = new Object();
    option.fileName = "گزارش افرایش ارزش کمپین";
    let dataExcelFile = [
      {
        1: "شماره کمپین بنری جایگزین",
        2: helpersNumber.toPersianNum(
          helpersNumber.toFormatFinanceNumber(campaignID)
        ),
      },
      {
        1: "================",
        2: "================",
        3: "================",
      },
      {
        1: "#",
        2: "ارزش قبل",
        3: "ارزش اضافه شده",
        4: "ارزش بعد",
        5: "تاریخ درج ارزش",
      },
    ];

    logs.forEach((log, index) => {
      dataExcelFile.push({
        1: helpersNumber.toPersianNum(index + 1),
        2: helpersNumber.toPersianNum(
          helpersNumber.addCommaToSeparateGroupThreeNumber(
            log.cal_campaign_amount_before
          )
        ),
        3: helpersNumber.toPersianNum(
          helpersNumber.addCommaToSeparateGroupThreeNumber(
            log.cal_campaign_amount_after
          )
        ),
        4: helpersNumber.toPersianNum(
          helpersNumber.addCommaToSeparateGroupThreeNumber(
            log.cal_campaign_amount_added
          )
        ),
        5:
          helpersNumber.toPersianNum(
            helpersTime.convertGregorianToJalali(
              log.cal_created_at.split(" ")[0]
            )
          ) +
          " " +
          helpersNumber.toPersianNum(
            moment.utc(log.cal_created_at).local().format("HH:mm:ss")
          ),
      });
    });

    option.datas = [
      {
        sheetData: dataExcelFile,
        columnWidths: [10, 10, 10, 10, 10],
      },
    ];

    const toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
    dataExcelFile = [];
  };

  const getCampaignValueLogs = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const allCampaignLogs = await sendRequestGetCampaignValueLogs(campaignID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!allCampaignLogs) {
      return;
    }
    setLogs(allCampaignLogs);
  };

  const sendRequestGetCampaignValueLogs = async (campaignID) => {
    const headersRequest = getHeaderForRequest();
    let logs;
    try {
      logs = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/campaign/manage/banner/alternative/logs-amount/" +
          campaignID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return logs.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateTableTagsLogs = () => {
    return logs.map((log, index) => {
      return (
        <tr>
          <td>{helpersNumber.toPersianNum(index + 1)}</td>
          <td className="number-finance">
            {helpersNumber.toPersianNum(
              helpersNumber.addCommaToSeparateGroupThreeNumber(
                log.cal_campaign_amount_before
              )
            )}
          </td>
          <td className="number-finance">
            {helpersNumber.toPersianNum(
              helpersNumber.addCommaToSeparateGroupThreeNumber(
                log.cal_campaign_amount_added
              )
            )}
          </td>
          <td className="number-finance">
            {helpersNumber.toPersianNum(
              helpersNumber.addCommaToSeparateGroupThreeNumber(
                log.cal_campaign_amount_after
              )
            )}
          </td>
          <td dir="ltr" className="number-finance">
            {helpersNumber.toPersianNum(
              helpersTime.convertGregorianToJalali(
                log.cal_created_at.split(" ")[0]
              )
            )}{" "}
            {helpersNumber.toPersianNum(
              moment.utc(log.cal_created_at).local().format("HH:mm:ss")
            )}
          </td>
        </tr>
      );
    });
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  نمایش لاگ افزایش ارزش کمپین
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <span className="pl-2 ">
                <span
                  className="btn btn-outline-success"
                  onClick={exportLogsExcel}
                >
                  <span className="pl-2">
                    <i className="fa fa-file-excel"></i>
                  </span>
                  <span>خروجی فایل Excel</span>
                </span>
              </span>
              <div className="table-responsive pt-2">
                <table className="table table-bordered table-dark tbl-td-white-space table-hover m-0">
                  <thead>
                    <th>#</th>
                    <th>ارزش قبل</th>
                    <th>ارزش اضافه شده</th>
                    <th>ارزش بعد</th>
                    <th>تاریخ درج ارزش</th>
                  </thead>
                  <tbody>{logs && generateTableTagsLogs()}</tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
